<div id="loading-indicator" [class.active]="loadingService.isLoading()">
  <div class="css-spinner"></div>
</div>

<div class="layout-main" #layout>
  <header appExcludeFromTabOrder [attr.inert]="isSidebarOverlayMode() && isSidebarVisible ? '' : null">
    <app-header></app-header>
  </header>

  <div class="content" id="content">
    <main
      class="main-section"
      [class.full-width]="!isMobile() && !isAuthenticated()"
      [attr.inert]="isSidebarOverlayMode() && isSidebarVisible ? '' : null">
      <app-breadcrumb></app-breadcrumb>
      <div class="page" id="page">
        <router-outlet />
      </div>
    </main>

    <button
      #sidebarToggle
      class="toggle-btn mobile-only"
      (click)="toggleSidebar()"
      aria-label="Toggle Sidebar"
      aria-controls="left-navigation"
      [attr.aria-expanded]="isSidebarVisible">
      <mat-icon>menu</mat-icon>
    </button>

    @if (isSidebarOverlayMode() || isAuthenticated()) {
      <div class="sidebar-overlay" [class.active]="isSidebarVisible" (click)="closeSidebar()" aria-hidden="true"></div>
      <aside
        id="left-navigation"
        class="left-panel"
        [class.open]="isSidebarVisible"
        [attr.aria-hidden]="isSidebarOverlayMode() && !isSidebarVisible ? 'true' : null"
        [attr.inert]="isSidebarOverlayMode() && !isSidebarVisible ? '' : null"
        [cdkTrapFocus]="isSidebarOverlayMode() && isSidebarVisible"
        [cdkTrapFocusAutoCapture]="isSidebarOverlayMode() && isSidebarVisible">
        <app-left-nav-panel></app-left-nav-panel>
      </aside>
    }
  </div>

  <app-footer
    appExcludeFromTabOrder
    [attr.inert]="isSidebarOverlayMode() && isSidebarVisible ? '' : null"
    (scrollToTopEmitter)="scrollToTop()"></app-footer>
</div>
